import { Injectable } from '@angular/core';
import { Route, Router } from '@angular/router';
import { Http } from '@angular/http';

import { Observable } from "rxjs/Observable";
import { Store, Action } from '@ngrx/store';
import { go } from "@ngrx/router-store";

import { AuthGuard } from './index';

import { DashboardComponent } from '../components/dashboard/dashboard.component';
import { PageNotFoundComponent } from '@api/components/page-not-found.component';
import { ModuleLoaderService } from "./module-loader.service";
import { HttpThresholdService } from '@threshold/services/http-threshold.service';
import { ExperienceService } from '@threshold/services/experience.service';

/**
 * Service to get and manage the routes
 */
@Injectable()
export abstract class RouterService {

    static initialRoutes(): Route[] {
        return [
            { path: '**', component: PageNotFoundComponent }
        ];
    }

    constructor(protected experienceService: ExperienceService, protected http: Http, protected router: Router, protected moduleLoaderService: ModuleLoaderService, protected store: Store<any>) { }

    /**
     * Return routes from backend and transform them into array of Route
     * @return Observable array of Routes
     */
    abstract getRoutes(): Observable<Route[]>;

    /**
     * The application bootstraps before the router is ready
     * which causes known-routes, to redirect to wildcard '**' component.
     * When the real routes have succesfully loaded, we go to the same route
     * with blank query params { '': '' }, which causes wildcard page to fire
     * again and validate the new routes.
     */
    public get hasRestoreRoute(): Action {

        // OpenID responding after successful login width /id_token which is the homepage
        if (this.router.url.indexOf('/id_token') >= 0) return go([''], { '': '' });

        // OpenID redirect_uri set to current page + hash e.g. window.location.href + #
        if (this.router.url.indexOf('#') != -1) return go([`${this.router.url.substr(0, this.router.url.indexOf('#'))}`], { '': '' })

        // Default
        if (this.router.url == '') return go(['']); else return go([this.router.url], { '': '' });
    }

    /**
     * Update Router with new  set of Routes
     * @param routes Set of Routes
     */
    setRoutes(routes: Route[]) {
        // Create mixed routes from the original, user dependant, and PageNotFound routes
        let routerConfig: Route[] = [
            ...routes,
            ...this.router.config
        ];

        // Router should use the new routes now
        this.router.resetConfig(routerConfig);
    }

    protected generateLoadChildrenRoute(routePath: string, url: string, isDashboard?: boolean, data?: any): Route {
        if (isDashboard) {
            return <Route>{
                path: routePath,
                component: DashboardComponent,
                data: Object.assign({url: url}, data),
                canActivate: [AuthGuard]
            };
        } else {
            return <Route>{
                path: routePath,
                loadChildren: () => {
                    // console.log('loadChildren', routePath, url);
                    return <any>this.moduleLoaderService.load(url);
                },
                data: data,
                canActivate: [AuthGuard]
            };
        }
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/services/router.service.ts